import 'client-only'
import Pusher from 'pusher-js'
import { isClient } from '../../constants/routing'
import { env } from '~/env.js'
import { getChannelName } from '../../lib/pusher-util'
// import { getURL } from '@basehub/shared-constants'
// import Cookies from 'js-cookie'

type PokeMessage = {
  mutatedEntryTypes: string[]
}

export function pusherReceiver(
  spaceID: string,
  onPoke: (message: PokeMessage) => Promise<void>
) {
  if (!isClient) throw new Error('pusherReceiver must be called on client')
  const pusher = new Pusher(env.NEXT_PUBLIC_PUSHER_KEY, {
    cluster: env.NEXT_PUBLIC_PUSHER_CLUSTER,
  })

  const channel = pusher.subscribe(getChannelName({ spaceID }))
  channel.bind('poke', onPoke)
  return channel
}

// // Receiver that connects directly to the Pump Durable Object via WebSocket.
// export function doReceiver(
//   spaceID: string,
//   onPoke: (message: PokeMessage) => Promise<void>
// ) {
//   if (!isClient) throw new Error('doReceiver must be called on client')
//   const session = Cookies.get('__session')
//   if (!session) throw new Error('No session found')

//   // Build WebSocket URL based on the pump worker URL, replacing http/https with ws/wss.
//   const baseURL = getURL('pumpWorker')
//   const wsURL =
//     baseURL.replace(/^http/, 'ws') +
//     `/poke?spaceID=${spaceID}&session=${session}`

//   const ws = new WebSocket(wsURL)

//   ws.addEventListener('message', async (event) => {
//     try {
//       const msg = JSON.parse(event.data) as PokeMessage
//       await onPoke(msg)
//     } catch {
//       // If it's not valid JSON, still trigger pull.
//       await onPoke({ mutatedEntryTypes: [] })
//     }
//   })

//   return ws
// }
